/* Package JSON Import will be here */
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getTranslate } from "react-localize-redux";
import Img from "react-image";
import { Row, Col, Badge, Divider, Button, Typography, Space, Tabs, Tag, Carousel, Modal } from "antd";
import { includes } from "lodash";
/* Package JSON Import will be here */

/* Project Import will be here */
import { Spinner, ButtonSpinner } from "components/Spinner";
import QuantityCounter from "containers/orders/QuantityCounter";
import CaseQuantityCounter from "containers/orders/CaseQuantityCounter";
import { validateWholesaler, getOrderVolumeByConversionRate, getCultureNumberFormat } from "utilities/utils";
import placeholderImg from "assets/img/banner-placeholder.png";
import { orderUpload } from "reducers/orders";
import { updateFavProductStatus } from "reducers/favouriteProducts";
import { openOrClosePromoDetailsModal } from "reducers/promotions";
import Constants from "utilities/appConstants";
import { setSelectedProductId } from "reducers/common";
import PromotionList from "../promotion/PromotionList";
import DiscountList from "../discount/DiscountList";
import { getProductDetails } from "reducers/product/productDetails";
import MinOrderQtyInfo from "components/products/MinOrderQtyInfo";
import GenerateComplaint from "containers/complaints/GenerateComplaint";
import modalConfirmationHook from "hooks/modalConfirmationHook";
import TooltipComp from "components/reusable/TooltipComp";
import SalesReturnEntry from "components/salesReturn/SalesReturnEntry";
import NoData from "components/reusable/NoData";
import OfferRibbon from "components/reusable/OfferRibbon";
import { deleteCartItem } from "reducers/cart";
import { GAViewItem } from "hooks/googleAnalyticsHooks";
/* Project Import will be here */

/* Const,Let & Var will be here */
const { Text } = Typography;
const { TabPane } = Tabs;
const { confirm } = Modal;
let isFavDisabled = false;
/* Const,Let & Var will be here */

class ProductDetail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isShowGenerateComplaint: false,
      currentSelectionId: parseInt(props.productId, 10)
    }

    /* Get product details data */
    this.props.actions.getProductDetails(parseInt(props.productId, 10), props.closeProductDetailsDrawer, props.pageType);

    /* Update selected product id for similar products */
    this.props.actions.setSelectedProductId(parseInt(props.productId, 10));

    /* Close the promotion details popup when the user click the AddToCart button */
    if (this.props.promotions.isShowPromoDetailsModal)
      this.props.actions.openOrClosePromoDetailsModal(false);
  }

  onVariantClick = (id) => {
    if (id !== this.state.currentSelectionId) {
      this.setState({ currentSelectionId: id }, () => {
        /* Update selected product id for similar products */
        this.props.actions.setSelectedProductId(this.state.currentSelectionId);

        /* Reload the similar product based on variant selected */
        this.props.onVariantChangeInProductDetails(this.state.currentSelectionId);

        /* GA - Track product view */
        if (window.isEnableGA)
          GAViewItem(this.props.productDetails.data[this.state.currentSelectionId]);
      });
    }
  };

  getBadgeClass = (key) => {
    if (this.state.currentSelectionId === key)
      return "badge--gram badge-selected";
    else if (this.props.cart.data[key])
      return "badge--gram badge-active";
    else
      return "badge--gram";
  };

  buttonRenderer = () => {
    const products = this.props.productDetails.data;
    const product = products[this.state.currentSelectionId];

    if (includes(this.props.cart.ids, product.ProductId) || this.props.cart.ids.length > 0)
      return this.props.translate("common.buttons.updateCart");
    else
      return this.props.translate("common.buttons.addToCart");
  };

  orderUpload = () => {
    validateWholesaler(this.props, () => this.props.actions.orderUpload());
  };

  /* add or remove the product from fav product */
  addOrRemoveFavProduct = (productInfo) => {
    if (!isFavDisabled)
      this.props.actions.updateFavProductStatus(productInfo, () => { isFavDisabled = false });

    isFavDisabled = true;
  };

  closeGenerateComplaintDrawer = () => {
    this.setState({ isShowGenerateComplaint: false });
  }

  openGenerateComplaintDrawer = () => {
    /* Generate complaint confirmation modal */
    modalConfirmationHook(this.props.translate("common.alerts.confirmation.generateComplaintConfirmationTitle"),
      this.props.translate,
      (() => {
        this.setState({ isShowGenerateComplaint: true });
      }));
  }

  getProductNameSpace = (product) => {
    const { appSettings } = this.props;

    if ((appSettings.isShowColorCode && product.Purchased !== undefined && product.Purchased !== 0) && (appSettings.isEnableComplaints && product.IsSaleable))
      return 18;
    else if ((appSettings.isShowColorCode && product.Purchased !== undefined && product.Purchased !== 0) || (appSettings.isEnableComplaints && product.IsSaleable)) {
      if (appSettings.isFavProductEnable && appSettings.isEnableComplaints)
        return 20;
      else
        return 22;
    }
    else
      return 22;
  }

  /* Get single or multiple images of the product */
  getProductImageSection = (product) => {
    if (product.Images.length > 0) {
      return (product.Images.map((imgUrl, index) => {
        return (<React.Fragment key={index}>{this.getProductImage(imgUrl)}</React.Fragment>);
      }));
    }
    else {
      return (this.getProductImage(product.ImageUrl));
    }
  }

  getProductImage = (imageUrl) => {
    return (
      <Img className="product-details-img border-radius-15" alt=""
        src={[imageUrl, placeholderImg]}
        loader={
          <div className="product-details-image-loader">
            <Spinner message={this.props.translate("products.productDetail.loadingImage")} />
          </div>
        }
      />
    )
  }

  showDeleteConfirm = (productId) => {
    let { translate } = this.props;

    confirm({
      title: translate("common.alerts.confirmation.cartItemDelete"),
      okText: translate("common.buttons.delete"),
      cancelText: translate("common.buttons.cancel"),
      okButtonProps: { size: "large", shape: "circle", style: { width: "100px" } },
      cancelButtonProps: { size: "large", shape: "circle", style: { width: "100px" } },
      centered: true,
      onOk: () => {
        this.props.actions.deleteCartItem([productId]);
      }
    });
  }

  render() {
    const { cart, orders, translate, appSettings, productDetails } = this.props;
    const products = this.props.productDetails.data;
    if (!productDetails.isDataLoaded || (productDetails.ids.length > 0 && products[this.state.currentSelectionId] === undefined)) {
      return (
        <div id="overlay-center">
          <Spinner message={this.props.translate("products.productDetail.loading")} />
        </div>
      );
    }
    else if (productDetails.ids.length === 0) {
      return (
        <div className="container pt-2" id="overlay-center">
          <NoData NoDataMessage={translate("products.productDetail.error.noProductDetailsFound")} />
        </div>
      );
    }
    else {
      const product = products[this.state.currentSelectionId];
      const cartItem = cart.data[product.ProductId];
      let grossAmount = null;
      let totalOrderVolume = 0;
      let qty = 0;

      if (cartItem && product.ConversionQty) {
        /* Check for QTY */
        if (cartItem.caseQTY && !cartItem.pieceQTY)
          qty = cartItem.caseQTY * product.ConversionQty
        else if (!cartItem.caseQTY && cartItem.pieceQTY)
          qty = cartItem.pieceQTY
        else if (cartItem.caseQTY && cartItem.pieceQTY)
          qty = (cartItem.caseQTY * product.ConversionQty) + cartItem.pieceQTY

        /* Before cart */
        if (cartItem.Price === undefined) {
          grossAmount = product.SellPrice * qty;
          totalOrderVolume = product.Weight * qty;
        }
        /* After cart */
        else {
          grossAmount = cartItem.Price * qty;
          totalOrderVolume = cartItem.Weight * qty;
        }
      }

      const productDetailsContent = (
        <div className="mt-2">
          <Row justify="left" className="product-details-price-font">
            {appSettings.isEnableMRP && <Col span={12} md={8} className="p-1">
              <i className="fa fa-tag" aria-hidden="true"></i>
              <span className="font-14 font-bold">{` ${translate("products.productLabel.mrp")} : `}</span>
              <span className="font-18 font-bold">{`${getCultureNumberFormat(product.MRP.toFixed(2), true)}`}</span>
            </Col>
            }
            {appSettings.isEnableSP &&
              <Col span={12} md={8} className="p-1">
                <i className="fa fa-tag" aria-hidden="true"></i>
                <span className="font-14 font-bold">{` ${translate("products.productLabel.ptr")} : `}</span>
                <span className="font-18 font-bold">{`${getCultureNumberFormat(product.SellPrice.toFixed(2), true)}`}</span>
              </Col>
            }
          </Row>

          {(appSettings.isShowStockQty || (appSettings.isEnablePlaceOrderCase && appSettings.isShowConversionQtyLabel) || appSettings.isEnableMinOrderQty) &&
            <Space size="large" className="flex-wrap p-1">
              {appSettings.isShowStockQty &&
                <span>
                  <Badge color="orange" />
                  <Text className="font-12">{translate("products.productLabel.stockQty")} : {product.SIH}</Text>
                </span>
              }

              {(appSettings.isEnablePlaceOrderCase && appSettings.isShowConversionQtyLabel) &&
                <span>
                  <Badge color="orange" />
                  <Text className="font-12">{translate("products.productLabel.ConversionQtyCase")} : {product.ConversionQty}{translate("products.productLabel.unit")}</Text>
                </span>
              }

              {(appSettings.isEnableMinOrderQty && product.MinORDQty > 0) &&
                <span>
                  <Badge color="orange" />
                  <Text className="font-12">{translate("products.productLabel.minQty")} : {product.MinORDQty}</Text>
                </span>
              }
            </Space>
          }

          <Row className="pt-2 pb-2">
            {appSettings.isEnablePlaceOrderCase &&
              <Col span={12} md={8}>
                <span className='case-quantity'>
                  <label>{translate("products.productLabel.case")} : </label>
                  <CaseQuantityCounter product={product} zeroCallback={this.showDeleteConfirm} />
                </span>
              </Col>
            }
            {appSettings.isEnablePlaceOrderPiece &&
              <Col span={12} md={!appSettings.isEnablePlaceOrderCase ? 12 : 8} xs={!appSettings.isEnablePlaceOrderCase ? 24 : 12}>
                <span className='piece-quantity'>
                  <label>{translate("products.productLabel.piece")} : </label>
                  <QuantityCounter product={product} zeroCallback={this.showDeleteConfirm} />
                </span>
              </Col>
            }
          </Row>

          {grossAmount !== null && qty > 0 &&
            <Row className="pt-2 pb-2 font-bold">
              <Col span={24} md={12} className="p-1">
                <Space>
                  <Text>{translate("products.productLabel.value")} {" "} <span className="font-10">{((appSettings.isShowTax && !appSettings.hideProductTax) ? translate("products.productLabel.withTax") : "")}</span>:</Text>
                  <Text>{getCultureNumberFormat(grossAmount.toFixed(2), true)}</Text>
                </Space>
              </Col>

              {appSettings.isEnableOrderVolume &&
                <Col span={24} md={12} className="p-1">
                  <Space>
                    <Text>{translate("products.productLabel.totalVolume")} {" "}:</Text>
                    <Text>{getOrderVolumeByConversionRate(appSettings, totalOrderVolume)}</Text>
                  </Space>
                </Col>
              }
            </Row>
          }

          {/* group variant section */}
          {
            productDetails.group[product.GroupId].length > 0 &&
            <Row className="pt-2 pb-2">
              <Col span={24}>
                {productDetails.group[product.GroupId].map((key) => {
                  return (
                    products[key] && products[key].Variant && (
                      <span key={key} onClick={() => { this.onVariantClick(key); }} className={this.getBadgeClass(key)}>
                        {products[key].Variant}
                      </span>
                    )
                  );
                })}
              </Col>
            </Row>
          }

          <Row justify="end">
            <Col span={24} md={8} className="p-2">
              <Button
                block
                type="primary"
                onClick={this.orderUpload}
                disabled={orders.isLoading || cart.deleteLoading}
                shape="round"
                size="large"
              >
                {this.buttonRenderer()}
                {(orders.isLoading || cart.deleteLoading) && <ButtonSpinner />}
              </Button>
            </Col>
          </Row>
        </div >
      );

      return (
        <React.Fragment>
          {/* Sidebar Desktop */}
          <div className="col-lg-8 pad--0--md pad--r--0 pad-x-15 w-auto m-auto">
            <OfferRibbon product={product} translate={translate}>
              <div className="product__detail--left">
                <div className="text-center">
                  <Carousel className="product-image-carousel product-detail-track" effect="fade" autoplay>
                    {this.getProductImageSection(product)}
                  </Carousel>

                  {/* SIH no stock error message */}
                  {appSettings.isShowSIHColorCode && product.SIH === 0 &&
                    <div className="text-center pt-3 mt-2">
                      <Tag className="round-radius mr-0 stockRedStyle out-of-stock-p-details" color="#ff0000">{translate("products.productLabel.outOfStockBasedAvailable")}</Tag>
                    </div>
                  }
                </div>
              </div>
            </OfferRibbon>
          </div>

          <div className="mar--t--md--15 pad--0--md pad-x-15 p-2 product-bottom-space">
            <div className="product__detail--right h-100">
              <Row>
                <Col span={this.getProductNameSpace(product)}>
                  <TooltipComp title={product.Name === undefined ? product.ProductName : product.Name}>
                    <div className="product__name--big word-wrap">
                      {product.Name === undefined ? product.ProductName : product.Name}
                    </div>
                  </TooltipComp>
                </Col>

                {/* Color code */}
                {(appSettings.isShowColorCode && product.Purchased !== undefined && product.Purchased !== 0) &&
                  <Col span={2} className="text-center mt-2">
                    <Badge status="processing" />
                  </Col>
                }
                {/* Favorite product icon - web view */}
                {(appSettings.isFavProductEnable) &&
                  <Col span={2}>   <div onClick={() => { this.addOrRemoveFavProduct(product) }} className="fav-product-header-icon-padding">
                    {product.IsFavourite ?
                      <i className="fa fa-heart fa-lg float-right fav-product-icon-color" aria-hidden="true"></i> :
                      <i className="fa fa-heart-o fa-lg float-right" aria-hidden="true"></i>
                    }
                  </div>
                  </Col>
                }

                {/* Generate complaint button */}
                {(appSettings.isEnableComplaints && product.IsSaleable) &&
                  <Col span={2}>
                    <TooltipComp title={translate("common.links.generateComplaint")}>
                      <Button
                        type="link"
                        icon={<i className="fa fa-exclamation-circle fa-lg complaint-big-icon" aria-hidden="true"></i>}
                        onClick={() => this.openGenerateComplaintDrawer()}
                        className="p-0"
                        size="large"
                      >
                      </Button>
                    </TooltipComp>
                  </Col>
                }
              </Row>

              {/* if sales return enabled show tab else show product details only */}
              {appSettings.isShowSalesReturn && product.IsSaleable && product.IsSalesReturn ?
                <Tabs defaultActiveKey="1" centered className="tab-bg-color product-details-tabs">
                  <TabPane tab={translate("products.productDetail.label.orderEntry")} key="1">
                    {productDetailsContent}
                  </TabPane>
                  <TabPane tab={translate("products.productDetail.label.salesReturnEntry")} key="2">
                    <div className="mt-2">
                      <SalesReturnEntry
                        selectedProduct={product}
                        translate={translate}
                        pageType={Constants.PRODUCT_DETAILS}
                        returnSummary={this.props.salesReturnSummary}
                      />
                    </div>
                  </TabPane>
                </Tabs> :
                <div>{productDetailsContent}</div>
              }

              <Divider />

              <div className="mt-3">
                <h6>{translate("products.productDetail.label.description")}</h6>
                <p className="break-all">{product.Description}</p>
              </div>

              {appSettings.isShowDisclaimers &&
                <div className="mt-3 font-12">
                  <MinOrderQtyInfo translate={translate} />
                </div>
              }
            </div>
          </div>

          {/* Product mapped scheme list */}
          {product.SchemeId !== 0 &&
            <React.Fragment>
              <div className="p-3 w-100"><Divider /></div>
              <h6 className="mb-0 ml-1 font-bold">
                {translate("products.productDetail.label.applicablePromotions")}
                <Badge className="ant-badge-green ml-1" showZero overflowCount={999} count={this.props.promotions.count} />
              </h6>

              <PromotionList requestPageType={Constants.PRODUCT_DETAILS} productId={this.state.currentSelectionId} params={this.props.productId} />
            </React.Fragment>
          }

          {/* Product mapped discount list */}
          {product.DiscountId !== 0 &&
            <React.Fragment>
              <div className="p-3 w-100"><Divider /></div>
              <h6 className="mb-0 ml-1 font-bold">
                {translate("products.productDetail.label.applicableDiscounts")}
                <Badge className="ant-badge-green ml-1" showZero overflowCount={999} count={this.props.discounts.count} />
              </h6>

              <DiscountList requestPageType={Constants.PRODUCT_DETAILS} productId={this.state.currentSelectionId} params={this.props.productId} />
            </React.Fragment>
          }

          {/* Complaint drawer screen */}
          {
            appSettings.isEnableComplaints && this.state.isShowGenerateComplaint &&
            <GenerateComplaint
              isShowGenerateComplaint={this.state.isShowGenerateComplaint}
              selectedSku={product}
              setIsShowGenerateComplaint={this.closeGenerateComplaintDrawer}
            />
          }
        </React.Fragment >
      );
    }
  }
}

const mapStateToProps = (state) => {
  return {
    promotions: state.promotions.details,
    discounts: state.discounts,
    cart: state.cart,
    orders: state.orders,
    translate: getTranslate(state.locale),
    appSettings: state.appSettings,
    productDetails: state.productDetails,
    localStore: state.localStore,
    salesReturnSummary: state.salesReturnSummary,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(
      {
        orderUpload,
        updateFavProductStatus,
        openOrClosePromoDetailsModal,
        setSelectedProductId,
        getProductDetails,
        deleteCartItem
      },
      dispatch
    )
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductDetail);